var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Yök Duyurular "),_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"ri-arrow-go-back-line"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }